
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"evenodd"}},[_c('rect',{attrs:{"opacity":".3","x":"2","y":"4","width":"20","height":"16","rx":"2"}}),_c('path',{attrs:{"opacity":".3","d":"M4 20l6.5-9 6.5 9z"}}),_c('path',{attrs:{"d":"M11 20l4.5-6 4.5 6z"}}),_c('circle',{attrs:{"opacity":".3","cx":"18.5","cy":"8.5","r":"1.5"}})])])
          )
        }
      }
    